import { render, staticRenderFns } from "./knowledgeSet.vue?vue&type=template&id=daa96380&scoped=true"
import script from "./knowledgeSet.vue?vue&type=script&lang=js"
export * from "./knowledgeSet.vue?vue&type=script&lang=js"
import style0 from "./knowledgeSet.vue?vue&type=style&index=0&id=daa96380&prod&lang=scss&scoped=true"
import style1 from "./knowledgeSet.vue?vue&type=style&index=1&id=daa96380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa96380",
  null
  
)

export default component.exports